var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58436 10.5V10.9375C9.58436 11.4016 9.39999 11.8467 9.0718 12.1749C8.74361 12.5031 8.29849 12.6875 7.83436 12.6875C7.37023 12.6875 6.92512 12.5031 6.59693 12.1749C6.26874 11.8467 6.08436 11.4016 6.08436 10.9375V10.5M12.5287 9.60941C11.8266 8.75 11.3308 8.3125 11.3308 5.94316C11.3308 3.77344 10.2228 3.00043 9.31093 2.625C9.18979 2.57523 9.07577 2.46094 9.03886 2.33652C8.87889 1.79211 8.43046 1.3125 7.83436 1.3125C7.23827 1.3125 6.78956 1.79238 6.63124 2.33707C6.59432 2.46285 6.4803 2.57523 6.35917 2.625C5.44616 3.00098 4.33929 3.77125 4.33929 5.94316C4.33792 8.3125 3.84218 8.75 3.13999 9.60941C2.84905 9.96543 3.10389 10.5 3.61276 10.5H12.0587C12.5648 10.5 12.818 9.96379 12.5287 9.60941Z",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.21f5cbab78f119ba57b72df96489ec4d.svg";
export { ForwardRef as ReactComponent };